import React, { useContext } from 'react'
import { Grid, GridCell, Text, View } from 'oio-react'
import { Link } from 'react-router-dom'
import { useUserList } from 'src/graphql/hooks'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'
import ThemeContext from 'src/libraries/contexts/Theme'

const GroupPeopleBlock = () => {
   const theme = useContext(ThemeContext)
   const { initiative } = useContext(InitiativeHierarchyContext)
   const { userList } = useUserList({
      userRelationshipFilter: {
         entityType: 'initiative',
         entityId: initiative.id,
         hasRoleParticipantElement: {
            roleType: 'primary',
            status: 'active'
         }
      },
      withRelationship: true,
      withRelationshipEntityType: 'initiative',
      withRelationshipEntityId: initiative.id
   })

   if (userList.items.length === 0) {
      return null
   }

   return (
      <View width="100%" paddingVertical={theme.tmpSpacing} paddingHorizontal="5px">
         <View padding="0px 0px 10px 0px">
            <Text size="1.5" weight="medium" color="#aaa">
               People
            </Text>
         </View>
         <View padding="5px">
            <Grid columns="1" spacing="0px">
               {userList.items.map((user) => {
                  const avatarUrl = user.avatarMedia
                     ? user.avatarMedia?.file.thumbnailUrlW48
                     : '/assets/images/avatarPlaceholder.svg'

                  return (
                     <GridCell key={user.id}>
                        <Link to={`/profile/${user.id}`}>
                           <View
                              display="flex"
                              alignItems="center"
                              position="relative"
                              width="100%"
                              height={theme.tmpSecondaryButtonHeight}>
                              <View
                                 flex="0 0 auto"
                                 width="18px"
                                 height="18px"
                                 borderRadius="3px"
                                 backgroundColor="#ddd"
                                 backgroundImage={`url(${avatarUrl})`}
                                 backgroundSize="cover"
                                 backgroundPosition="bottom center"
                                 style={{
                                    backgroundRepeat: 'no-repeat'
                                 }}
                              />
                              <View flex="1 1 auto" padding="0px 15px">
                                 <Text
                                    color={theme.tmpButtonTextColor}
                                    size={theme.tmpSecondaryButtonTextSize}
                                    style={{
                                       whiteSpace: 'nowrap',
                                       overflow: 'hidden',
                                       textOverflow: 'ellipsis'
                                    }}>
                                    {user.fullName}
                                 </Text>
                              </View>
                           </View>
                        </Link>
                     </GridCell>
                  )
               })}
            </Grid>
         </View>
      </View>
   )
}

export default GroupPeopleBlock
